import React from "react";

import {
  Container,
  Wrapper,
  Column,
  StyledStickyContainer,
  StyledSticky,
  StickyWrapper,
  BigImage,
  TextBox,
  Title,
  Text,
  PhoneBox,
} from "./styles";

export const StickyColumn = ({ data, color, reverse }) => {
  return (
    <Container color={color}>
      <Wrapper reverse={reverse}>
        <Column>
          <BigImage>{data.main}</BigImage>
        </Column>
        <Column>
          <StyledStickyContainer>
            <StyledSticky>
              {({ style }) => (
                <StickyWrapper style={{ ...style }}>
                  <TextBox>
                    <Title>{data.title}</Title>
                    <Text>{data.text}</Text>
                  </TextBox>
                  <PhoneBox>{data.phone}</PhoneBox>
                </StickyWrapper>
              )}
            </StyledSticky>
          </StyledStickyContainer>
        </Column>
      </Wrapper>
    </Container>
  );
};
